import * as React from 'react';

import type {FilterObject} from 'nutshell-core/types';

import {ReportChart} from '../../reports/report-chart';
import type {ChartReportParams} from '../../reports/report-types';

import {PagesReportProvider} from './pages-report-provider';

type Props = {
    activeFilters: FilterObject[];
    onParamChange: (arg1: any, arg2: boolean) => void;
    reportParams: ChartReportParams;
    reportDataSummary?: React.ReactNode;
    hasBorder?: boolean;
    hasGap?: boolean;
    headerExtraContent?: React.ReactNode;
    height?: number;
    containerHeight?: number;
};

export function LandingPagesReportChart(props: Props) {
    return (
        <PagesReportProvider>
            <ReportChart hasBorder={false} reportKey='landingPages' {...props} />
        </PagesReportProvider>
    );
}
